import { render, staticRenderFns } from "./ChangePriceProduct.vue?vue&type=template&id=61267eea"
import script from "./ChangePriceProduct.vue?vue&type=script&lang=js"
export * from "./ChangePriceProduct.vue?vue&type=script&lang=js"
import style0 from "./ChangePriceProduct.vue?vue&type=style&index=0&id=61267eea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports